import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { PollMessageComponent } from './poll-message/poll-message';
import { PollQuestionsComponent } from './poll-questions/poll-questions';
import { MultipleQuestionComponent } from './poll-questions/multiple-question/multiple-question';
import { SingleQuestionComponent } from './poll-questions/single-question/single-question'
import { OpenQuestionComponent } from './poll-questions/open-question/open-question';
import { RatingQuestionComponent } from './poll-questions/rating-question/rating-question';
import { Ionic2RatingModule } from 'ionic2-rating';
import { PipesModule } from '../../../pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    IonicModule,
    Ionic2RatingModule,
    PipesModule,
    TranslateModule
  ],
  exports: [
    PollMessageComponent,
    PollQuestionsComponent,
    RatingQuestionComponent,
    OpenQuestionComponent,
    SingleQuestionComponent,
    MultipleQuestionComponent,
  ],
  declarations: [
    PollMessageComponent,
    PollQuestionsComponent,
    RatingQuestionComponent,
    OpenQuestionComponent,
    SingleQuestionComponent,
    MultipleQuestionComponent
  ],
  providers: [],
})
export class PollComponentsModule { }



// WEBPACK FOOTER //
// ./src/pages/poll/components/poll-components.module.ts